{
    "SignInWith_Title": "Aanmelden met",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Andere opties"
}